import { render, staticRenderFns } from "./EmailQueueTable.vue?vue&type=template&id=51207fe4&scoped=true&"
import script from "./EmailQueueTable.vue?vue&type=script&lang=js&"
export * from "./EmailQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./EmailQueueTable.vue?vue&type=style&index=0&id=51207fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51207fe4",
  null
  
)

export default component.exports